<template>
  <eTableList
    :style="{ 'margin-bottom': creditRound === '1' ? '20px' : '0' }"
    :table-data="tableData"
    :table-label="tableLabel"
    :index-show="false"
    :right-span-method="objectSpanMethod"
  >
    <template #applyAmount="{ scope: { row } }">
      <span>{{ row.applyAmount | thousandsSeparator }}</span>
    </template>
    <template #sceneReportAttachPath="{ scope: { row } }">
      <span
        class="table-handle-btn"
        @click="showView(row.sceneReportAttachPath, row.sceneReportAttachName)"
        >现场审查报告</span
      >
    </template>
    <template #testReportAttachPath="{ scope: { row } }">
      <span
        v-if="row.testReportAttachPath"
        class="table-handle-btn"
        @click="showView(row.testReportAttachPath, row.testReportAttachName)"
        >检测报告</span
      >
    </template>
    <template #report="{ scope: { row } }">
      <span
        v-if="row.testReportAttachPath"
        class="table-handle-btn"
        @click="showViewReport(row)"
        >评价证书</span
      >
    </template>
  </eTableList>
</template>

<script>
import eTableList from '@/modules/projectA/components/common/e-table-list-merge';
import Api from '@/modules/projectA/api/ESorganization';
import utils from '@/modules/projectA/utils/utils';

export default {
  name: 'EvaluativeInfo',
  components: { eTableList },
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    // 评价类型 1：初评，2：复评
    creditRound: {
      type: String,
      default: '1',
    },
    // 供应商类型 101：生产商，103：流通商
    supplierType: {
      type: String,
      default: '101',
    },
    // 1:报告审核 2:评价业务管理
    type: {
      type: String,
      default: '1',
    },
  },
  computed: {
    tableLabel() {
      const creditRound = this.creditRound === '1' ? '初评' : '复评';
      return [
        {
          label: '覆盖范围',
          align: 'center',
          param: 'level',
          width: 100,
          render({ level }) {
            return level ? `${level}级` : '';
          },
        },
        {
          label: '产品名称',
          param: 'productName',
          align: 'center',
          minWidth: 150,
        },
        {
          label: this.supplierType === '101' ? '检测费' : '产品检测费',
          slot: 'applyAmount',
          align: 'center',
          width: 110,
        },
        { label: '现场审查得分', param: 'fieldReview', align: 'center' },
        { label: '现场审查结论', param: 'fieldReviewDesc', align: 'center' },
        {
          label: `${creditRound}产品检测得分`,
          param: 'productTest',
          align: 'center',
          hidden: this.supplierType !== '101',
        },
        {
          label: `${creditRound}综合得分`,
          param: 'compositeScore',
          align: 'center',
          hidden: this.supplierType !== '101',
        },
        {
          label: '有效期',
          param: 'grade',
          align: 'center',
          hidden: this.type === '1',
          render({ creditStartDateStr, showCreditDeadline }) {
            return creditStartDateStr
              ? `${creditStartDateStr}至${showCreditDeadline}`
              : '';
          },
        },
        { label: `${creditRound}评级`, param: 'grade', align: 'center' },
        {
          label: '现场审查报告',
          align: 'center',
          minWidth: 100,
          slot: 'sceneReportAttachPath',
        },
        {
          label: `${creditRound}检测报告`,
          align: 'center',
          minWidth: 100,
          slot: 'testReportAttachPath',
          hidden: this.supplierType !== '101',
        },
        {
          label: `${creditRound}评价证书`,
          align: 'center',
          minWidth: 100,
          slot: 'report',
          hidden:
            [3, 12, 13].includes(this.tableData.subStatus) || this.type === '2',
        },
      ].filter((item) => !item.hidden);
    },
  },
  methods: {
    /**
     * 查看报告
     * @param attachmentUrl
     * @param attachmentName
     */
    async showView(attachmentUrl, attachmentName) {
      const res = await Api.downLoadEvaluationFile({
        attachmentUrl,
        attachmentName,
      });
      const i = attachmentName.lastIndexOf('.');
      utils.downFile(
        res,
        attachmentName.substr(0, i),
        attachmentName.substr(i)
      );
    },
    /**
     * 查看报告
     * @param data
     */
    showViewReport(data) {
      const { evaluationItemId, id } = data;
      const url = this.$router.resolve({
        path: '/ES/viewReport',
        query: {
          evaluationItemId,
          id,
        },
      }).href;
      window.open(url);
    },
    /**
     * 合并单元格
     * @param row
     * @param columnIndex
     * @returns {{colspan: number, rowspan: *}|{colspan: number, rowspan: number}}
     */
    objectSpanMethod({ row, columnIndex, rowIndex }) {
      if (columnIndex > 2 && columnIndex < 10) {
        if (rowIndex === 0) {
          return {
            rowspan: this.tableData.length,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
  },
};
</script>

<style scoped></style>
